import React from 'react';
import PropTypes from 'prop-types';
import FuzzySearch from 'react-fuzzy';
import './Search.css';

const Search = ({ options, selectGravestone }) => {
  return (
    <div id='search'>
      <FuzzySearch
        className='searchStones'
        list={options}
        keys={['name']}
        onSelect={selectGravestone}
        width='100%'
        maxResults={100}
        placeholder='Search by name or date'
        threshold={0.3}
        resultsTemplate={(options, state, styles, clickHandler) => {
          return state.results.map((val, i) => {
            return (
              <div
                key={`searchResultFor${i}`}
                onClick={() => clickHandler(i)}
                className='result'
              >
                {val.name}
              </div>
            );
          });
        }}
      />
    </div>
  );
};

export default Search;

Search.propTypes = {
  options: PropTypes.arrayOf(PropTypes.object),
};

Search.defaultProps = {
  
};



// WEBPACK FOOTER //
// ./src/components/Search.jsx